<template>
  <div class="mx-2 mt-3">
    <v-row no-gutters class="" align="center" justify="space-between">
      <v-col cols="auto">
        <img src="@/assets/images/icon/file-text.png" width="25px" />
      </v-col>
      <v-col
        cols="auto"
        class="pl-2 font-weight-medium subtitle-1 darkblue--text"
      >
        ROI
      </v-col>
      <v-spacer />
      <!-- <v-col
        cols="auto"
        v-if="roiType === 'PROMOTIONAL OBJECTS' && isLoggedInAsBO"
      >
        <dialog-add-roi :code="ioCode" @getlistData="getData" />
      </v-col>
      <v-col
        cols="auto"
        class="pl-2"
        v-else-if="roiType === 'CRM' && isLoggedInAsBO"
      >
        <dialog-add-crm :code="ioCode" @getlistData="getData" />
      </v-col> -->
    </v-row>
    <!-- <v-row v-if="roiType === 'PROMOTIONAL OBJECTS' && itemsRoi.length !== 0"> -->
    <v-row v-if="itemsCard.length !== 0">
      <v-col cols="12" v-for="item in itemsCard" :key="item.id">
        <card-roi-gimmick
          :dataItem="item"
          :isloginBO="isLoggedInAsBO"
          class="px-3"
          @getlistData="getData"
        />
      </v-col>
    </v-row>
    <!-- <v-row v-else-if="roiType === 'CRM' && itemsRoi.length !== 0">
      <v-col cols="6" v-for="item in itemsRoi" :key="item.id">
        <card-roi-crm :dataItem="item" class="px-3" />
      </v-col>
    </v-row> -->
    <h3 class="grey--text text-center py-5" v-else>
      No Data Available
    </h3>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import CardRoiGimmick from '@/components/SpendingReport/CardRoiGimmick';
// import CardRoiCrm from '@/components/SpendingReport/CardRoiCrm';
import ProgressDialog from '../../components/progress_dialog';
// import Swal from 'sweetalert2';
import LoginAsMixin from '@/mixins/LoginAsMixin';

export default {
  name: 'SpendingReportRoi',
  components: {
    // CardRoiCrm,
    CardRoiGimmick,
    'progress-dialog': ProgressDialog
  },
  props: {
    // roiType: {
    //   type: String,
    //   required: true
    // },
    // ioCode: {
    //   type: String,
    //   required: true
    // },
    itemsCard: {
      type: Array,
      required: false
    },
    isloginBO: {
      type: Boolean,
      required: false
    }
  },
  mixins: [LoginAsMixin],
  data() {
    return {
      itemsRoi: [],
      progressDialogLoading: false
    };
  },
  async mounted() {
    // await this.getData();
  },
  methods: {
    getData() {
      this.$emit('getlistData');
    }
    // getData() {
    //   this.progressDialogLoading = true;
    //   this.$store
    //     .dispatch('mroi/getAll')
    //     .then(data => {
    //       this.progressDialogLoading = false;
    //       if (data.code === 200) {
    //         this.itemsRoi = data.data;
    //         // if (this.roiType === 'PROMOTIONAL OBJECTS') {
    //         //   this.itemsRoi = data.data.roi_gimmick;
    //         // } else if (this.roiType === 'CRM') {
    //         //   this.itemsRoi = data.data.roi_crm;
    //         // }
    //         // this.itemsRoi = Number(data.data.total);
    //       } else {
    //         Swal.fire('Failed!', data.response.data.message.text_en, 'error');
    //       }
    //     })
    //     .catch(err => {
    //       Swal.fire('Failed!', err.response.data.message.text_en, 'error');
    //       this.progressDialogLoading = false;
    //     });
    // }
  }
};
</script>

<style scoped></style>
